<template>
  <div>
      <h5>Dashboard</h5>
      <img src="@/assets/dashboard.png" />
  </div>
</template>
<script>

export default {
  name: "Dashboard",
  components: { 

  },
  data() {
   return {
    };
  },
  created: function() {
  },
  methods: {
  }
};
</script>
<style scoped>

</style>
